import { RowSelectedEvent } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SideDrawerComponent } from '@app/core/components/side-drawer-container/side-drawer/side-drawer.component';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { BusinesscoItem, LogisticService } from '@app/services/logistic.service';
import { PurchaseStatusItem, PurchHeadService, PurchHeadsGet, PurchHeadsGetParams } from '@app/services/purch-head.service';
import { TypeaheadService } from '@app/services/typeahead.service';
import { Subscription } from 'rxjs';
import { PurchLineItem } from '../purch-head/purch-head-purch-lines/purch-head-purch-lines.component';

@Component({
    selector: 'tt-purch-heads',
    templateUrl: './purch-heads.component.html',
    styleUrls: ['./purch-heads.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchHeadsComponent implements OnInit, OnDestroy {
    public params: PurchHeadsGetParams;

    public get?: PurchHeadsGet;

    public grid?: GridOptions;

    public companies: BusinesscoItem[] = [];

    public purchaseStatuses: PurchaseStatusItem[] = [];

    public portalUsers: Item[] = [];

    public purchHeads: Item[] = [];

    public gridPurchLines?: GridOptions<PurchLineItem>;

    private subscription: Subscription;

    @ViewChild(SideDrawerComponent)
    public sideDrawer?: SideDrawerComponent;

    constructor(
        state: StateService,
        public purchHead: PurchHeadService,
        private logistic: LogisticService,
        private typeahead: TypeaheadService,
        public cdr: ChangeDetectorRef,
        private modal: ModalService,
    ) {
        this.params = { ...state.getStateParams(), webpage: state.getCurrentPath().replace('/', '') } as unknown as PurchHeadsGetParams;
        this.subscription = this.purchHead.currentPurchHead$.subscribe({
            next: (get) => {
                if (!get) this.sideDrawer?.close();
            },
        });
    }

    public openPurchHeadCreate(event: MouseEvent) {
        this.modal.openStateDialog({ state: 'purchheadcreate', params: `${this.params.argtype}/${this.params.argvalue}` });
    }

    public onHeadDelete() {
        this.grid?.gridfunc?.read(false);
    }

    public supplierSearch = async () => {
        return this.typeahead.searchCustomer({ cust_name: this.get?.searchtext_supplier || '', custtype: 'S', lastselect: 'SEARCH' });
    };

    public onSupplierSelected(event?: Item) {
        if (!!this.get) {
            this.get.supplier_no = !!event ? +event.item_id : '0';
            this.searchPurchases();
        }
    }

    public searchPurchases() {
        this.readGrid();
    }

    public onSearchTextChanged(event: string) {
        if (event === '') {
            this.searchPurchases();
        }
    }

    public onPurchHeadSelected(event: RowSelectedEvent) {
        console.log(event);
        if (event.node.isSelected()) {
            this.purchHead.setPurchHeadFromParams({ purch_internal_no: event.node.data['purch_internal_no'] });
        } else {
            // this.purchHead.setPurchHeadFromParams(null);
        }
        //
    }

    private async readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_purchheads_purchhead_grid').setLoadDataFunction({ method: 3059, parameters: () => this.get });
        } else {
            await this.grid.gridfunc?.read();
        }

        const selectedRows = this.grid.gridfunc?.getGridApi().getSelectedRows() ?? [];

        if (selectedRows.length === 0) {
            this.purchHead.setPurchHeadFromParams(null);
        }

        this.loadPurchHeads();
    }

    private async loadGet() {
        this.get = await this.purchHead.getPurchHeads(this.params);
        this.cdr.markForCheck();
    }

    private async loadCompanies() {
        this.companies = await this.logistic.getCompanies();
    }

    private async loadPortalUsers() {
        this.portalUsers = await this.logistic.getPurchaserPortalUsers({ add_all: '1' });
    }

    private async loadPurchaseStatuses() {
        this.purchaseStatuses = await this.purchHead.getPurchaseStatuses({
            addall: '1',
            add_include_active: '1',
        });
    }

    private async loadPurchHeads() {
        if (!!this.get) this.purchHeads = await this.purchHead.getPurchHeadsList(this.get);
    }

    private async init() {
        this.loadCompanies();
        this.loadPurchaseStatuses();
        this.loadPortalUsers();
        await this.loadGet();
        this.readGrid();
    }

    ngOnInit(): void {
        this.init();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.purchHead.setPurchHeadFromParams(null);
    }
}
